export function TitleizeFilter() {
  return function(input) {
    // https://github.com/sindresorhus/titleize
    return (input || '')
      .toLowerCase()
      .replace(/(?:^|\s|-)\S/g, s => s.toUpperCase());
  };
}
